module.exports = __webpack_public_path__ + "static/img/ag.c8adbf23.svg";